import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal, ProgressBar } from "react-bootstrap";
import Icon from "../Icon";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { WebSocketContext } from "../../websocket/websocket";

const SlowSyncModal: React.FC = () => {
    const { pendingObjectCountRef } = useContext(WebSocketContext)!;
    const [show, setShow] = useState(false);
    const maxObjects = useRef(0);
    const [progress, setProgress] = useState(0);
    const [receivedObjects, setRO] = useState(0);
    const showTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const startedRef = useRef<Boolean>(false);
    const prevCountRef = useRef<number>(0);

    useEffect(() => {
        // Запускаем таймер показа модалки на 3 секунды при начале синхронизации
        showTimerRef.current = setInterval(() => {
            console.log('pendingObjectCountRef = ', pendingObjectCountRef.current);
            if (pendingObjectCountRef.current > 100 && !startedRef.current) {
                console.log('start sync dialog');
                setShow(true);
                maxObjects.current = pendingObjectCountRef.current;
                setRO(pendingObjectCountRef.current);
                prevCountRef.current = pendingObjectCountRef.current;
                startedRef.current = true;

            } else if (pendingObjectCountRef.current === 0) {
                console.log('finish sync dialog');
                setShow(false);
                maxObjects.current = 0;
                prevCountRef.current = 0;
                startedRef.current = false;
                return;
            }

            const currentCount = pendingObjectCountRef.current;

            // Если число объектов растёт — увеличиваем максимум
            if (currentCount > prevCountRef.current) {
                maxObjects.current = currentCount;
                setRO(currentCount);
            }

            // Если число объектов уменьшается — обновляем прогресс
            if (currentCount < prevCountRef.current && maxObjects.current > 0) {
                console.log('progress = ', Math.round(((maxObjects.current - currentCount) / maxObjects.current) * 100));
                setProgress(Math.round(((maxObjects.current - currentCount) / maxObjects.current) * 100));
            }

            prevCountRef.current = currentCount;

        }, 3000);

        return () => {
            if (showTimerRef.current) {
                clearTimeout(showTimerRef.current);
            }
        };
    }, []);

    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
            style={{ zIndex: 99999 }}
        >
            <Modal.Header className="text-center">
                <Modal.Title>
                    <Icon icon={faSync} spin /> Синхронизация...
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                <p className="mb-2">Получено объектов: {receivedObjects}<br />Синхронизировано:</p>
                <ProgressBar
                    now={progress}
                    label={`${progress}%`}
                    striped
                    animated
                    variant="info"
                    style={{ height: 28, fontSize: 14 }}
                />
            </Modal.Body>
        </Modal>
    );
};

export default SlowSyncModal;
